import script from "./VistoriaOld.vue?vue&type=script&setup=true&lang=js"
export * from "./VistoriaOld.vue?vue&type=script&setup=true&lang=js"

import "./VistoriaOld.vue?vue&type=style&index=0&id=ff03bbb4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff03bbb4"]])

export default __exports__